/* @ngInject */
function postsService ($rootScope, ConnectorWebService, CustomerCompanyService, CONSTANTS, Utils, ModalService) {
  const service = {
    getPostCategories,
    getPostCategoriesParentless,
    createPost,
    editPost,
    archivePost,
    getPosts,
    getAllCategories,
    getPostCategoryParented,
    getPostById,
    getPostByArchived,
    getUsersWithReadFlag,
    resendPostEmail,
    downloadAttachment,
    updatePinnedPost,
    registerAttachmentLog,
    getAttachmentLog,
    reactToPost,
    getUrlForPostId,
    copyPostUrlToClipboard,
    attachAssetsToPost,
    removeAssetFromPost,
    bindPostToCampaign,
    unbindPostFromCampaign,
    createPostView,
    showPostModal
  }
  return service

  function getPostCategories (search, top, skip) {
    let url = CONSTANTS.URL_POSTS_CATEGORY

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function getPostCategoriesParentless () {
    return ConnectorWebService.get(CONSTANTS.URL_POSTS_CATEGORY_PARENTLESS)
  }

  function createPost (mData) {
    return ConnectorWebService.post(CONSTANTS.URL_POSTS, mData)
  }

  function editPost (sId, mData) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID, [sId])
    return ConnectorWebService.put(sUrl, mData)
  }

  function archivePost (sId, mData) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ARCHIVE_ID, [sId])
    return ConnectorWebService.put(sUrl, mData)
  }

  function getPosts (iTop, iSkip, oFilters) {
    let sUrl = CONSTANTS.URL_POSTS

    const {
      isPinned,
      isArchived,
      read,
      term,
      createdAt,
      expiredAt,
      authorId,
      categoryId,
      score,
      campaignId
    } = oFilters

    if (iTop || iSkip) {
      sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, iTop, iSkip)
    }

    sUrl = Utils.fnAddQueryToUrl(sUrl, {
      isPinned,
      isArchived,
      read,
      term,
      createdAt,
      expiredAt,
      campaignId
    })

    sUrl = Utils.addQueryStringFromArray(sUrl, 'authorId', Utils.convertToArray(authorId))
    sUrl = Utils.addQueryStringFromArray(sUrl, 'categoryId', Utils.convertToArray(categoryId))
    sUrl = Utils.addQueryStringFromArray(sUrl, 'score', Utils.convertToArray(score))

    return ConnectorWebService.get(sUrl)
  }

  function getAllCategories (top, skip, term) {
    let sUrl = CONSTANTS.URL_POSTS_CATEGORY_CHILDLESS

    if (top || skip) {
      sUrl = Utils.fnAddTopSkipQueriesToUrl(sUrl, top, skip)
    }

    if (term) {
      sUrl = Utils.fnAddQueryToUrl(sUrl, { term })
    }

    return ConnectorWebService.get(sUrl)
  }

  function getPostCategoryParented (iId) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_PARENT_CATEGORIES_ID, [iId])
    return ConnectorWebService.get(sUrl)
  }

  function getPostById (sId) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID, [sId])
    return ConnectorWebService.get(sUrl)
  }

  function getPostByArchived (sId) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ARCHIVE_ID, [sId])
    return ConnectorWebService.get(sUrl)
  }

  function getUsersWithReadFlag (sId) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_USER_READ, [sId])
    return ConnectorWebService.get(sUrl)
  }

  function resendPostEmail (sPostId, sUserId) {
    const sUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID_SEND_EMAIL, [sPostId])
    return ConnectorWebService.post(sUrl, { userId: sUserId })
  }

  function downloadAttachment (attachmentId) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [attachmentId])
    url = Utils.fnAddQueryToUrl(url, { downloadModule: 'POSTS' })

    return Utils.downloadFile(url)
  }

  function updatePinnedPost (params) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID_PIN, [params.id])
    return ConnectorWebService.put(url, { isPinned: params.isPinned })
  }

  function registerAttachmentLog (attachmentId, postId, type) {
    const url = CONSTANTS.URL_POSTS_ATTACHMENT_LOG
    const params = {
      attachmentId,
      postId,
      type
    }

    return ConnectorWebService.post(url, params)
  }

  function getAttachmentLog (attachmentId, postId) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ATTACHMENT_LOG_ID, [attachmentId])
    url = Utils.fnAddQueryToUrl(url, { postId })

    return ConnectorWebService.get(url)
  }

  function reactToPost (postId, options) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID_REACT, [postId])
    return ConnectorWebService.post(url, options)
  }

  function getUrlForPostId (postId) {
    const companyBaseUrl = CustomerCompanyService.getCompanyBaseUrl()
    const postsModuleBaseUrl = `${companyBaseUrl}/posts`
    const company = $rootScope.oUserCompany

    return Utils.fnAddQueryToUrl(postsModuleBaseUrl, {
      company: company.id,
      post: postId
    })
  }

  function copyPostUrlToClipboard (postId) {
    const postUrl = getUrlForPostId(postId)

    return navigator.clipboard.writeText(postUrl)
  }

  function attachAssetsToPost (postId, assetsId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID_ASSETS, [postId])
    const data = Array.isArray(assetsId) ? { assetsId } : { assetsId: [assetsId] }

    return ConnectorWebService.post(url, data)
  }

  function removeAssetFromPost (postId, assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID_ASSETS_ASSETID, [postId, assetId])

    return ConnectorWebService.fnDelete(url)
  }

  function bindPostToCampaign (params = {}) {
    const { assetId, selectedCampaign } = params

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID_BIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url, { campaignId: selectedCampaign })
  }

  function unbindPostFromCampaign (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID_UNBIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url)
  }

  function createPostView (postId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_POSTS_ID_VIEWS, [postId])
    return ConnectorWebService.post(url)
  }

  function showPostModal (post, index, totalPosts, storedPosts) {
    return ModalService.showModal({
      templateId: 'newPost.html',
      templateUrl: '/posts/dialogs/post/post-dialog.html?$$REVISION$$',
      destroyable: true,
      observeChanges: true,
      allowMultiple: true,
      data: {
        _postId: post.id,
        _editMode: false,
        _currentPostIndex: index,
        _totalPosts: totalPosts,
        _storedPosts: storedPosts,
        previousPost: () => {
          if (index > 0) {
            ModalService.close()
            service.showPostModal(storedPosts[index - 1], index - 1, totalPosts, storedPosts)
          }
        },
        nextPost: () => {
          if (index < totalPosts - 1) {
            ModalService.close()
            service.showPostModal(storedPosts[index + 1], index + 1, totalPosts, storedPosts)
          }
        }
      }
    })
  }
}

export { postsService }
